import { Button, Col, Modal, Row, Table, Input, message, Space } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import qs from 'qs';
import { SearchOutlined } from '@ant-design/icons';
import { useTestStore } from '../../../../store/testReducer';
import { useNavigate } from 'react-router-dom';
import routes from '../../../../controller/Routes';
import { getQuestion } from '../../../../controller/api/questionServices';
import { getAdminDetail } from '../../../../controller/localStroageHandler';
import { getTechnology } from '../../../../controller/api/globalServices';
import Highlighter from 'react-highlight-words';
const AddquestionInSection = ({
  addQuestionPopup,
  setQuestionPopUp,
  addquestionindex,
  setAddQuestionIndex,
  selectedQuestion,
  setSelectedQuestion,
  setCurrentSectionSectionName,
  currentSectionName
}) => {
  const [data, setData] = useState();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });
  const [total, setTotal] = useState(0);
  // const [search, setSearch] = useState('');
  const [technologiesList, setTechnologyList] = useState([]);
  const { questions, updateTest } = useTestStore((state) => state);
  const [sectionList, setSectionList] = useState([]);
  const userDetail = getAdminDetail();
  useEffect(() => {
      getTechnology({ search: '', data: 'all' }).then(res => {
              let techList = res?.data?.result?.map((tech) => ({
                text: tech.name,
                value: tech._id,
              }));
              setTechnologyList(techList)
            }).catch(err => {
              console.log("err ===> ", err)
            })
    getQuestion({ id: userDetail?.organization_id?._id }, { section: currentSectionName }).then(res => {
      setData(res?.data?.questions)
    }).catch(err => {
      console.log("err ===>", err)
    })
  }, []);

   const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  const handleSearch = (
    selectedKeys,
    confirm,
    dataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={`${selectedKeys[0] || ''}`}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys , confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>         
          <Button 
            type="primary"
            onClick={() => handleSearch(selectedKeys , confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters)
              handleSearch([], confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownOpenChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });
  const columns = [
    {
      title: 'Question',
      dataIndex: 'title',
      sorter: true,
      sorter: (a, b) => {
        console.log("a ===> ", a)
        return a.title.localeCompare(b.title);
      },
      ...getColumnSearchProps('title'),
    },
    {
      title: 'Difficulty',
      dataIndex: 'difficulty',
            sorter: true,
      sorter: (a, b) => {
        return a.difficulty.localeCompare(b.difficulty);
      },
      filterSearch: true,
      filters: [
        {
          text: 'Easy',
          value: 'easy',
        },
        {
          text: 'Medium',
          value: 'medium',
        },
        {
          text: 'Hard',
          value: 'hard',
        },
      ],
      onFilter: (value, record) => record.difficulty.toLowerCase() === value.toLowerCase(),
      render: (text) => (
        <span
          className={`${text == 'easy'
              ? 'text-success'
              : text == 'medium'
                ? 'text-warning'
                : 'text-danger'
            }`}
        >
          {text}
        </span>
      ),
      className: 'text-capitalize fw-medium',
    },
    {
      title: 'Technology Used',
      dataIndex: 'technology',
      filterSearch: true,
      filters: technologiesList,
       onFilter: (value, record) => {
    return record.technology?.some((tech) => tech._id === value);
  },
      render: (technology) => {
        return (
          <div className='d-flex gap-2 flex-wrap p-1'>
            {technology?.map((val, index) => {
              return (
                <span
                  key={index}
                  className='skill-bg-color text-muted rounded-1 d-flex gap-1'
                  style={{
                    fontSize: '14px',
                    padding: '0px 5px',
                    cursor: 'pointer',
                  }}
                >
                  {val?.name}
                </span>
              );
            })}
          </div>
        );
      },
    },
    {
      title: 'Section',
      dataIndex: 'section',
      // filters: sectionList,
    },
    {
      title: '',
      dataIndex: '',
      render: (record) => {
        const checkPersent = selectedQuestion?.filter(
          (val) => val._id == record._id
        );
        return checkPersent?.length ? (
          <Button
            className='rounded-5 fw-bold d-flex justify-content-center align-items-center fw-semibold remove-btn-border-color text-remove-color-custom custom-remove-hover-btn'
            onClick={() => {
              const filterData = selectedQuestion?.filter(
                (val) => val._id !== record._id
              );
              setSelectedQuestion(filterData);
            }}
          >
            REMOVE
          </Button>
        ) : (
          <Button
            className='rounded-5 fw-bold d-flex justify-content-center align-items-center fw-semibold btn-border-color text-color-custom custom-hover-btn'
            // onClick={() => navigate(routes.admin.dashboard.test.add)}
            onClick={() => {
              let data = [...questions];
              const checkQuestPersentinsection = data?.filter((val) => {
                let checkquest = val?.questions?.filter(
                  (ques) => ques._id == record._id
                );
                if (checkquest?.length) {
                  return val;
                }
              });
              if (checkQuestPersentinsection?.length) {
                message.info('This question is already in section');
              } else {
                setSelectedQuestion([...selectedQuestion, record]);
              }
            }}
          >
            ADD
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    // getSection()
    // .then((res) =>
    // setSectionList(
    //   res.data?.section_types?.map((val) => {
    //     return {
    //       text: val?.label,
    //       value: val?.key,
    //     };
    //   })
    //   )
    //   )
    //   .catch((err) => console.log('err === >', err));
    //   getAllTechnology()
    //   .then((res) => {
    //     setTechnologyList(
    //       res?.data?.technologies?.map((val) => {
    //         return {
    //           text: val?.name,
    //           value: val?.id,
    //         };
    //       })
    //       );
    //     })
    //     .catch((err) => console.log('err ===== > ', err));
    setTableParams({ ...tableParams, filters: { ...tableParams?.filters, section: [currentSectionName] } })
  }, []);
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };
  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: (selectedRowKeys, selectedRows) => {
  //     setSelectedRowKeys(selectedRowKeys);
  //     setselectedRows([...selectedRowsdata, selectedRows]);
  //     console.log(
  //       `selectedRowKeys: ${selectedRowKeys}`,
  //       'selectedRows: ',
  //       selectedRows
  //     );
  //   },
  // };
  // const fetchData = () => {
  //   setLoading(true);
  //   getQuestion({ ...tableParams, search: search }).then((res) => {
  //     setTotal(res.data.count);
  //     setData(res.data.result);
  //     setLoading(false);
  //   });
  // };
  // useEffect(() => {
  //   fetchData();
  // }, [JSON.stringify(tableParams), search]);

  const handleSave = () => {
    let testData = [...questions];
    testData[addquestionindex].questions = [...selectedQuestion];
    updateTest(testData);
    setAddQuestionIndex(null);
    setSelectedQuestion([]);
    setQuestionPopUp(false);
  };
  const handlediscard = () => {
    setAddQuestionIndex(null);
    setSelectedQuestion([]);
    setQuestionPopUp(false);
  };
  return (
    <Modal
      title=''
      open={addQuestionPopup}
      width={'75%'}
      closeIcon={null}
      footer={null}
    >
      <Row gutter={[12, 12]}>
        <Col span={17}>
          {/* <Input
            placeholder='Search Here'
            prefix={<SearchOutlined />}
            size='large'
            value={search}
            allowClear
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          /> */}
        </Col>
        <Col span={7} className='d-flex justify-content-end'>
          <Button
            className='rounded-5 fw-bold d-flex justify-content-center align-items-center fw-semibold btn-border-color text-color-custom custom-hover-btn'
            onClick={() => {
              navigate(routes.admin.dashboard.questionnaire.add);
            }}
          >
            Add +
          </Button>
        </Col>
        <Col span={24}>
          <Table
            className='table-container'
            scroll={{
              y: 220,
              x: 500,
            }}
            // rowSelection={{
            //   type: 'checkbox',
            //   ...rowSelection,
            // }}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={data}
            pagination={{
              ...tableParams.pagination,
              showSizeChanger: true,
              total: total,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total}`,
            }}
            loading={loading}
            onChange={handleTableChange}
          />
        </Col>
        <Col xl={16} lg={16} md={14} sm={12} xs={7}></Col>
        <Col xl={8} lg={8} md={10} sm={12} xs={17}>
          <Row gutter={[15, 15]}>
            <Col span={12}>
              <Button
                className='w-100 text-color-custom fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
                onClick={() => handlediscard()}
              >
                Discard
              </Button>
            </Col>
            <Col span={12}>
              <Button
                type='primary'
                className='w-100 button-color fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
                onClick={() => handleSave()}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export default AddquestionInSection;
